import React from 'react';
import AnimatedSection from './AnimatedSection';
import './SharedStyles.css';
import './Support.css';

const Support = () => {
  return (
    <AnimatedSection direction="fade" className="support-section" delay={200} id="support">
      <div className="section-content-wrapper">
        <h2 className="section-title">
          <span className="title-accent">Support</span>
        </h2>
        <div className="content-card">
          <p className="support-label">Contact our support:</p>
          <a
            href="mailto:support@bg5gamescom.net"
            className="support-email"
          >
            <span className="email-text">support@bg5gamescom.net</span>
            <span className="email-icon">→</span>
          </a>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Support;
